import React from "react";
import { Stack, NumberInput, Text, Group, TagsInput } from "@mantine/core";
import { MultipleChoiceFieldOptions } from "./fieldOptionsTypes";

export interface MultipleChoiceFieldOptionsEditorProps {
  value: MultipleChoiceFieldOptions;
  onChange: (options: MultipleChoiceFieldOptions) => void;
  minValue: number | null;
  maxValue: number | null;
  onMinValueChange: (value: number | null) => void;
  onMaxValueChange: (value: number | null) => void;
  maxValueError?: string;
  error?: string;
}

export const MultipleChoiceFieldOptionsEditor: React.FC<
  MultipleChoiceFieldOptionsEditorProps
> = ({
  value,
  onChange,
  minValue,
  maxValue,
  onMinValueChange,
  onMaxValueChange,
  maxValueError,
  error,
}) => {
  const handleValuesChange = (tags: string[]) => {
    const values = tags.map((v) => v.trim()).filter((v) => v);
    onChange({ ...value, values });
  };

  return (
    <Stack gap="sm">
      <Text size="xs" c="dimmed">
        Enter the options users can select from (multiple selections allowed).
      </Text>

      <TagsInput
        label="Options"
        placeholder="Type an option and press Enter"
        description="Add options by typing and pressing Enter or comma"
        value={value.values ?? []}
        onChange={handleValuesChange}
        error={error}
        splitChars={[","]}
        clearable
        required
        withAsterisk
        size="sm"
      />

      <Group grow>
        <NumberInput
          label="Min Selections"
          placeholder="No minimum"
          description="Minimum choices required"
          value={minValue ?? ""}
          onChange={(val) => onMinValueChange(val === "" ? null : Number(val))}
          min={0}
          size="sm"
        />

        <NumberInput
          label="Max Selections"
          placeholder="No maximum"
          description="Maximum choices allowed"
          value={maxValue ?? ""}
          onChange={(val) => onMaxValueChange(val === "" ? null : Number(val))}
          error={maxValueError}
          min={minValue ?? 1}
          size="sm"
        />
      </Group>
    </Stack>
  );
};
